import React, { useEffect, useMemo, useState } from "react";
import { Form, Row, Button, Input, OverlayTrigger } from "react-bootstrap";
import { useProductMapping } from "modules/dashboards/actionables/store";
import { manualUpdationLog, useManualUpdate } from "./store";
import { useToast } from "modules/navbar/top/store/toasterStore";
import CardDiv from "modules/common/card-div/CardDiv";
import { Select } from "antd";
import {
  calculateSkus,
  filterAndMapWarehouses,
} from "modules/utilities/utility";
import { comboProductMappings, requiredWarehouses } from "../../config";
import StockHistory from "./StockHistory";

function ManualUpdation() {
  const { productsData, isLoading, fetchProducts } = useProductMapping();
  const { wareHousesData, fetchWareHouses, postModuleUpdate } =
    useManualUpdate();
  const { setToaster } = useToast();

  useEffect(() => {
      fetchProducts();
      fetchWareHouses();
  }, []);

  const skus = useMemo(
    () => calculateSkus(productsData, comboProductMappings),
    [productsData]
  );

  const warehouses = useMemo(
    () => filterAndMapWarehouses(wareHousesData, requiredWarehouses),
    [wareHousesData]
  );

  const [type, setType] = useState(null);
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);
  const [selectedSku, setSelectedSku] = useState(null);
  const [quantity, setQuantity] = useState();
  const { fetchManualUpadtion, manualUpdationData } = manualUpdationLog();
  const handleSubmit = (event) => {
    event.preventDefault();
    postModuleUpdate(
      {
        type: type,
        warehouseId: selectedWarehouse,
        skuId: selectedSku,
        quantity: quantity,
      },
      setToaster
    );
    // Reset the form state
    setSelectedWarehouse(null);
    setSelectedSku(null);
    setType(null);
    setQuantity("");
    fetchManualUpadtion(1);
  };

  const handleClear = () => {
    setSelectedWarehouse(null);
    setSelectedSku(null);
    setType(null);
  };

  return (
    <div className="d-flex flex-column gap-4">
      <CardDiv
        title={<div className="fs-2">Manual Updation</div>}
        component={
          <div className="" style={{ minHeight: "20vh", width: "40rem" }}>
            <Form layout="vertical" onSubmit={handleSubmit}>
              <Form.Group controlId="typeSelect">
                <Select
                  onChange={(event) => setType(event)}
                  value={type}
                  className="w-100"
                  allowClear
                  onClear={() => {
                    handleClear();
                  }}
                  placeholder="Select"
                  options={[
                    {
                      label: "Add Incoming",
                      value: "incoming",
                    },
                    {
                      label: "Add Outgoing",
                      value: "outgoing",
                    },
                  ]}
                />
              </Form.Group>
              <div style={{ marginTop: "2%" }}>
                {type && (
                  <>
                    <Form.Group controlId="warehouseSelect">
                      <Form.Label>Warehouse</Form.Label>
                      <Form.Control
                        as="select"
                        value={selectedWarehouse}
                        onChange={(event) => setSelectedWarehouse(event.target.value)}
                        required
                      >
                        <option value="" className="d-none">
                          {" "}
                        </option>
                        {warehouses?.map((warehouse) => (
                          <option key={warehouse.value} value={warehouse.value}>
                            {warehouse.label}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>

                    <Form.Group controlId="skuSelect">
                      <Form.Label>Skus</Form.Label>
                      <Form.Control
                        as="select"
                        value={selectedSku}
                        onChange={(event) => setSelectedSku(event.target.value)}
                        required
                      >
                        <option value="" className="d-none">
                          {" "}
                        </option>
                        {skus?.map((sku) => (
                          <option key={sku.value} value={sku.value}>
                            {sku.label}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>

                    <Form.Group controlId="quantityInput">
                      <Form.Label>Quantity</Form.Label>
                      <Form.Control
                        type="text"
                        name="quantity"
                        placeholder="Enter quantity"
                        onChange={(event) => setQuantity(event.target.value)}
                        required
                      />
                    </Form.Group>
                    <Form.Group className="mt-5 w-100">
                      <Button
                        type="submit"
                        variant="primary"
                        disabled={isLoading}
                      >
                        {isLoading ? "Adding..." : "Add"}
                      </Button>
                    </Form.Group>
                  </>
                )}
              </div>
            </Form>
          </div>
        }
      />
      <CardDiv
        title={<div className="fs-2">Manual Updation Logs</div>}
        component={<StockHistory/>}
      />
    </div>
  );
}

export default ManualUpdation;
